import { useEffect } from 'react';

/**
 * Calls `handler` when a mousedown event occurs outside all provided refs.
 * Pass a single ref or an array of refs (useful for trigger + menu pairs).
 */
const useClickOutside = (refs, handler, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    const targets = Array.isArray(refs) ? refs : [refs];
    const listener = (e) => {
      if (targets.every((r) => !r.current || !r.current.contains(e.target))) {
        handler(e);
      }
    };
    document.addEventListener('mousedown', listener);
    return () => document.removeEventListener('mousedown', listener);
  }, [refs, handler, enabled]);
};

export default useClickOutside;
